// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { AppIcon, Tooltip } from '@loa/ui-components';
import { OVERRIDE_FIELD_LABELS } from '../../types/policyOverride';
import './PolicyOverrideIndicator.css';

type PolicyOverrideIndicatorProps = Readonly<{
  hasOverride: boolean;
  overriddenFields?: string[];
  reason?: string;
  size?: 'mini' | 'tiny' | 'small';
}>;

function formatOverriddenFields(fields?: string[]): string {
  if (!fields || fields.length === 0) return 'None';
  return fields.map(f => OVERRIDE_FIELD_LABELS[f] || f).join(', ');
}

export function PolicyOverrideIndicator({
  hasOverride,
  overriddenFields,
  reason,
  size = 'small',
}: PolicyOverrideIndicatorProps) {
  if (!hasOverride) return null;

  return (
    <Tooltip
      trigger={
        <span
          className="policy-override-indicator__icon"
          aria-label={`Override active: ${formatOverriddenFields(overriddenFields)}`}
        >
          <AppIcon name="exchange" color="orange" />
        </span>
      }
      content={
        <div className="policy-override-indicator__tooltip">
          <strong>Detail Override Active</strong>
          <p>Overridden: {formatOverriddenFields(overriddenFields)}</p>
          {reason && (
            <p className="policy-override-indicator__tooltip-reason">
              Reason: {reason.length > 100 ? `${reason.substring(0, 100)}...` : reason}
            </p>
          )}
        </div>
      }
      position="top"
      size={size === 'mini' ? 'mini' : 'small'}
    />
  );
}
